/**
 * Randall's Refined Scripts — Navigation Module
 * ==============================================
 * Mobile navigation drawer and search modal functionality.
 */

var RRS = window.RRS || {};

RRS.Navigation = (function() {
  'use strict';

  var mobileNav = null;
  var menuToggle = null;
  var searchModal = null;

  /**
   * Initialize Mobile Navigation
   */
  function initMobileNav() {
    mobileNav = document.getElementById('mobile-nav');
    menuToggle = document.querySelector('.header__menu-toggle');
    var closeBtn = mobileNav ? mobileNav.querySelector('[data-action="close-mobile-nav"]') : null;
    var overlay = mobileNav ? mobileNav.querySelector('.mobile-nav__overlay') : null;

    if (!mobileNav || !menuToggle) return;

    menuToggle.addEventListener('click', openMobileNav);
    if (closeBtn) closeBtn.addEventListener('click', closeMobileNav);
    if (overlay) overlay.addEventListener('click', closeMobileNav);

    // Close on Escape
    document.addEventListener('keydown', handleMobileNavEscape);

    // Trap focus within mobile nav
    mobileNav.addEventListener('keydown', trapMobileNavFocus);
  }

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    // Focus first link
    var firstLink = mobileNav.querySelector('.mobile-nav__link');
    if (firstLink) firstLink.focus();
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    menuToggle.focus();
  }

  function handleMobileNavEscape(e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.getAttribute('aria-hidden') === 'false') {
      closeMobileNav();
    }
  }

  function trapMobileNavFocus(e) {
    if (e.key !== 'Tab' || !mobileNav) return;

    var focusable = mobileNav.querySelectorAll(
      'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var firstFocusable = focusable[0];
    var lastFocusable = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  }

  /**
   * Initialize Search Modal
   */
  function initSearchModal() {
    searchModal = document.getElementById('search-modal');
    var searchBtns = document.querySelectorAll('[data-action="open-search"]');
    var closeBtns = document.querySelectorAll('[data-action="close-search"]');
    var overlay = searchModal ? searchModal.querySelector('.search-modal__overlay') : null;

    if (!searchModal) return;

    searchBtns.forEach(function(btn) {
      btn.addEventListener('click', openSearch);
    });

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeSearch);
    });

    if (overlay) overlay.addEventListener('click', closeSearch);

    // Close on Escape
    document.addEventListener('keydown', handleSearchEscape);
  }

  function openSearch() {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var searchInput = document.getElementById('search-input');
    if (searchInput) {
      setTimeout(function() {
        searchInput.focus();
      }, 100);
    }
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Return focus to trigger button
    var lastTrigger = document.querySelector('[data-action="open-search"]');
    if (lastTrigger) lastTrigger.focus();
  }

  function handleSearchEscape(e) {
    if (e.key === 'Escape' && searchModal && searchModal.getAttribute('aria-hidden') === 'false') {
      closeSearch();
    }
  }

  /**
   * Initialize Sticky Header
   */
  function initStickyHeader() {
    var header = document.querySelector('.header');
    if (!header) return;

    var ticking = false;

    function updateHeader() {
      var scrollY = window.scrollY;

      if (scrollY > 100) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    });
  }

  /**
   * Public API
   */
  return {
    init: function() {
      initMobileNav();
      initSearchModal();
      initStickyHeader();
    },
    openMobileNav: openMobileNav,
    closeMobileNav: closeMobileNav,
    openSearch: openSearch,
    closeSearch: closeSearch
  };
})();
